module.exports = __webpack_public_path__ + "img/c7609c4.jpg";